<template>
  <div id="app">
    <div v-if="firmware" id="firmware" style="width: 100%; height:550px"></div>
    <div v-if="bluetooth" id="bluetooth" style="width: 100%; height:550px"></div>
    <div v-if="audio" id="audio" style="width: 100%; height: 550px"></div>
  </div>
</template>
<script>
export default {
  name: "FirmwareVersion",
  components: {},
  data() {
    return {
        firmware:true,
        bluetooth:false,
        audio:false
    };
  },
  methods: {
    getData() {
      this.$api.rootV1.post(
        "/web/statistics/firewareversion",
        {},
        (res) => {
          if (res.errcode == 0) {
            let fireware = res.data.fireware;
            let audio_fireware=res.data.audio_fireware;
            let bluetooth_fireware=res.data.bluetooth_fireware;

            let dates1 = [],totalCounts1 = [];
            for (let item of fireware) {
              dates1.push(item.device_fireware_version);
              totalCounts1.push({value:item.totalCount,name:item.device_fireware_version});
            }
            this.drawChart('firmware',dates1, totalCounts1);

            let dates2 = [],totalCounts2 = [];
            for (let item of bluetooth_fireware) {
              dates2.push(item.device_bluetooth_version);
              totalCounts2.push({value:item.totalCount,name:item.device_bluetooth_version});
            }
            this.drawChart('bluetooth',dates2, totalCounts2);

            let dates3 = [],totalCounts3 = [];
            for (let item of audio_fireware) {
              dates3.push(item.device_audio_version);
              totalCounts3.push({value:item.totalCount,name:item.device_audio_version});
            }
            this.drawChart('audio',dates3, totalCounts3);
          }
        }
      );
    },
    drawChart( name,dates, totalCounts) {
      var echarts = require("echarts");
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById(name));
      // 指定图表的配置项和数据
      let option = {
        title: { text: name+" version", left: "center" },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          type: 'scroll',
          orient: "vertical",
          left: "left",
          data: dates,
        },
        series: [
          {
            name: "count",
            type: 'pie',
            radius: '73%',
            center: ['50%', '60%'],
            data: totalCounts,
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/main/statistics/FirmwareVersion.vue